/** Strip revision/annotation/highlight markup that should not influence AI critique/search. */
export function stripAgentInvisibleMarkup(text: string): string {
  return text.replace(
    /<\/?(?:insertion|inserted|deletion|deleted|insert|annotation|mark|highlight)(?:\s[^>]*)?>/gi,
    "",
  );
}
